const { resolveRevenueRolloutConfig } = require('./revenue/revenueRolloutConfig');

export const REVENUE_ROLLOUT_CONFIG = resolveRevenueRolloutConfig(process.env);

export const CLASS_SEASONS_PRODUCTION_APPROVAL = 'build-allowlisted-classes-production';
export const CLASS_SEASONS_PRODUCTION_PROJECT_ID = 'tribechallengetracker';

export function resolveClassSeasonsEnabled(environment = process.env) {
  if (environment.REACT_APP_CLASS_SEASONS_ENABLED !== 'true') return false;
  if (environment.NODE_ENV !== 'production') return true;

  const channel = environment.REACT_APP_CLASS_SEASONS_RELEASE_CHANNEL;
  const projectId = environment.REACT_APP_FIREBASE_PROJECT_ID;
  if (channel === 'staging') {
    return Boolean(projectId) && projectId !== CLASS_SEASONS_PRODUCTION_PROJECT_ID;
  }
  if (channel === 'production') {
    return projectId === CLASS_SEASONS_PRODUCTION_PROJECT_ID
      && environment.REACT_APP_CLASS_SEASONS_PRODUCTION_RELEASE_APPROVED
        === CLASS_SEASONS_PRODUCTION_APPROVAL;
  }
  return false;
}

export const FEATURE_FLAGS = {
  HOME_EMBER_FLOATING_VIEW_ENABLED: process.env.REACT_APP_HOME_EMBER_FLOATING_VIEW_ENABLED !== 'false',
  HOME_AI_COACH_ENABLED: process.env.REACT_APP_HOME_AI_COACH_ENABLED === 'true',
  CLASS_SEASONS_ENABLED: resolveClassSeasonsEnabled(process.env),
  EMBER_ONBOARDING_V3_ENABLED: process.env.REACT_APP_EMBER_ONBOARDING_V3_ENABLED !== 'false',
  PROGRESS_OVERHAUL_M1_ENABLED: process.env.REACT_APP_PROGRESS_OVERHAUL_M1_ENABLED === 'true',
  WORKOUT_EXPLORE_ENABLED: process.env.REACT_APP_WORKOUT_EXPLORE_ENABLED === 'true',
  WORKOUT_TRAINING_PLANS_ENABLED: process.env.REACT_APP_WORKOUT_TRAINING_PLANS_ENABLED === 'true',
  TRIBE_FEED_ENABLED: true,
  TRIBE_FEED_REACTIONS_ENABLED: true,
  FOLLOW_FEATURE_ENABLED: true,
  BILLING_LIVE: REVENUE_ROLLOUT_CONFIG.billing_live,
  PRO_PAYWALL_ENABLED: REVENUE_ROLLOUT_CONFIG.pro_paywall_enabled,
  PRO_PAYWALL_MESSAGE_EXPERIMENT_ENABLED: REVENUE_ROLLOUT_CONFIG.pro_paywall_message_experiment_enabled,
  CREATOR_PILOT_ENABLED: REVENUE_ROLLOUT_CONFIG.creator_pilot_enabled,
  TRIBE_MOMENTUM_ENABLED: REVENUE_ROLLOUT_CONFIG.tribe_momentum_enabled,
  PAID_PACKS_ENABLED: REVENUE_ROLLOUT_CONFIG.paid_packs_enabled,
};

const WORKOUT_FLOW_FEATURE_FLAGS = {
  explore: 'WORKOUT_EXPLORE_ENABLED',
  plans: 'WORKOUT_TRAINING_PLANS_ENABLED',
};

export function isWorkoutFlowEnabled(flow, flags = FEATURE_FLAGS) {
  const flagName = WORKOUT_FLOW_FEATURE_FLAGS[flow];
  return !flagName || flags?.[flagName] === true;
}

export function resolveWorkoutFlow(flow, flags = FEATURE_FLAGS) {
  return isWorkoutFlowEnabled(flow, flags) ? flow : 'hub';
}

export const FOLLOW_FEATURE_BETA_UIDS = new Set([
  'M98xIszlUick0Zw9SJTbfIN1ho13',
  'wOkXIFQoTZPRccE1GWpdPGdco373',
]);

export function isFollowFeatureEnabledForUser(userOrUid) {
  const uid = typeof userOrUid === 'string' ? userOrUid : userOrUid?.uid;
  return FEATURE_FLAGS.FOLLOW_FEATURE_ENABLED || FOLLOW_FEATURE_BETA_UIDS.has(uid);
}
